import { IActivity, ISection } from '@sdk/contracts';
import { Button } from 'antd';
import { useMemo } from 'react';

import {
  ActionsWrapper,
  ActivityStatus,
  Cover,
  InfoWrapper,
  Wrapper
} from './IntroductionActivityItem.styles';
import { SyncedIconWrapper } from './IntroductionActivityItem.styles';

import { ActivityActions } from '@/components/Activities/ActivityActions';
import { Icon } from '@/components/Icon';
import { SyncedIcon } from '@/components/SyncedIcon';
import { ACTIVITY_ICONS } from '@/constants';
import { useActivityPreview } from '@/hooks';
import { useCurrentSection, useIntroductionForm } from '@/store';
import { ECourseContentStep } from '@/types';

type Props = {
  activity: IActivity;
  section: ISection;
};

export const IntroductionActivityItem: React.FC<Props> = ({ activity, section }) => {
  const { setActivityId } = useActivityPreview();
  const { setActivity, setIsOpen } = useIntroductionForm();
  const { setCurrentSectionId } = useCurrentSection();

  const handleEdit = () => {
    setCurrentSectionId(section._id);
    setActivity(activity);
    setIsOpen(true);
  };

  const handlePreview = () => setActivityId(activity._id);

  const isSyncedToParent = useMemo(
    () => activity.parentActivity || (activity.syncedActivities ?? []).length > 0,
    [activity]
  );

  const canEdit = useMemo(() => !activity.parentActivity, [isSyncedToParent]);

  return (
    <Wrapper>
      <InfoWrapper>
        <Cover>
          <Icon size={24} i={ACTIVITY_ICONS[activity.type]} />
          {activity.resource ? <ActivityStatus active={activity.active} /> : <Icon i="Warning" />}
          {isSyncedToParent && (
            <SyncedIconWrapper>
              <SyncedIcon size={20} />
            </SyncedIconWrapper>
          )}
        </Cover>
        <div>{activity.name}</div>
      </InfoWrapper>
      <ActionsWrapper>
        {canEdit && (
          <Button
            type="text"
            size="small"
            icon={<Icon i="Edit" size={20} />}
            onClick={handleEdit}
          />
        )}
        <Button
          type="text"
          size="small"
          icon={<Icon i="DocumentView" size={20} />}
          onClick={handlePreview}
        />
        <ActivityActions
          target={ECourseContentStep.INTRODUCTION}
          section={section}
          activity={activity}
        />
      </ActionsWrapper>
    </Wrapper>
  );
};
